import { FormTextField } from '@ipfabric/ui-components/FormTextField/FormTextField';
import type { FormSnippet } from '@ipfabric/ui-components/utils/formSnippets/FormSnippet';
import { hookFormZod } from '@ipfabric/ui-components/utils/hookForm/hookFormZod';
import { sessionTimeouts } from '@ipfabric/utils';
import { z } from 'zod';
import type { DiscoverySettingsObject } from '../../model/DiscoverySettingsObject';

export type SessionTimeoutFieldValues = { sessionTimeout: string };
export type SessionTimeoutOutputValues = { sessionTimeout: number };

export const sessionTimeout: FormSnippet<
  DiscoverySettingsObject,
  SessionTimeoutFieldValues,
  SessionTimeoutOutputValues
> = {
  render: ({ form }) => (
    <FormTextField
      control={form.control}
      type='number'
      name='sessionTimeout'
      description='Time to wait after last data were received'
      label='Device session'
      endAdornment='seconds'
      inputWidthClassName='w-60'
    />
  ), // Placeholder for the actual component
  fromModel: (model, fieldValuesDraft) => {
    fieldValuesDraft.sessionTimeout = model.timeouts?.session?.toString() ?? '';
  },
  toModel: (transformedValues, modelDraft) => {
    modelDraft.timeouts ??= {};
    modelDraft.timeouts.session = transformedValues.sessionTimeout;
  },
  schema: z.object({
    sessionTimeout: hookFormZod.numberInputWith(
      hookFormZod.minMax(sessionTimeouts.min, sessionTimeouts.max),
    ),
  }),
};
